import React, { FC } from 'react'

import { IconPieChartProps } from './IconPieChart.types'
import * as Styled from './styles/IconPieChart.style'

import { nonThemeableRules } from '../../ruleSet'

const IconPieChart: FC<IconPieChartProps> = ({
  size = nonThemeableRules.defaultSize as number as IconPieChartProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconPieChartProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M156.76 57.52v-.19c0-.06 0-.1-.06-.15a80.33 80.33 0 0 0-53.34-53.69h-.09a80.07 80.07 0 1 0 53.49 54.05zm-9-1.72L86 74.06l18.79-61.66a72.36 72.36 0 0 1 43.01 43.39zM80 152A72 72 0 1 1 97.13 10.08l-21 68.76a4 4 0 0 0 5 5l68.93-20.37A71.95 71.95 0 0 1 80 152z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconPieChart
